
































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class CommonInputModal extends Vue {
  @Prop({default: false})
  private show!: boolean;

  @Prop()
  private value!: string;

  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop()
  private rules?: Array<any>;

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: false})
  private dark!: boolean;

  @Prop()
  private maxWidth?: string;

  @Prop()
  private color?: string;

  @Prop({default: false})
  private dense?: boolean;

  @Prop({default: true})
  private rounded?: boolean;

  @Prop()
  private appendIcon?: string;

  @Watch('value')
  watchPropValue() {
    this.inputData = this.value;
  }

  @Watch('show')
  watchPropShow() {
    this.isShow = this.show;
  }

  @Watch('isShow')
  watchIsShow() {
    this.$emit('changeShow', this.isShow)
  }

  private inputData: string = '';
  private isShow: boolean = false;

  private handleClick() {
    this.isShow = false;
    this.$emit('changeShow', this.isShow)
  }

}
